import { animate, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Course, CourseResponse, Courses, courseResponse } from 'app/models/course-response';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { UserService } from '../../Services/user.service';
import { AppSettings } from '../../app-settings';
import { EventService } from "../../Services/event.service";



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger(
      'pspSubMenuAnimate', [
      transition(':enter', [
        style({ height: 0 }),
        animate('200ms', style({ height: '*' }))
      ]),
      transition(':leave', [
        style({ height: '*' }),
        animate('200ms', style({ height: 0 }))
      ])
    ]
    ),
    trigger('coursePopUpInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.3s', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.3s', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {
  public logoUrl: any;
  public menuImgUrl: any;
  public openMenuImgUrl: any;
  public lockImage: any;
  public fname: String;
  public items: string[] = ['Logout', 'Test activity'];
  public userMenu: Boolean = false;
  public sidebarHeight = 0;
  public courseMenuData: any;
  public homeMenu: any;
  public extensionIcon: any;
  public extensionBlueIcon: any;
  public extensionOrangeIcon: any;
  public homeMenuHover: any;
  public homeHoverIcon: boolean = false;
  hasSeenGS: boolean;
  showUpgradeNowBtn: boolean = false;
  gettingStartedSection = [];
  userInfoUpdateSubscription: Subscription;
  tabVerbal: String = "tabVerbal";
  tabQuant: String = "tabQuant";
  tabFree: String = "tabFree";
  gettingStarted: String = "gettingStarted";
  tabActive: String = "gettingStarted";
  closeImage: string = AppSettings.cdnUrl + "assets/images/close.png";
  userIconImgUrl: string = AppSettings.cdnUrl + "assets/images/user_icon.png";
  courseExpiredImage: string = AppSettings.cdnUrl + "assets/images/expiryAlertImg.png";
  closeUserPop: string = AppSettings.cdnUrl + "assets/images/user_pop_exit.png";
  liveSessionId: number;
  upgradeNowBtnURL = AppSettings.publicSiteURL + "/pricing?scroll=scroll-to-buy-now";
  IRCourseNames: any = [{ "name": "Integrated Reasoning" }];
  VerbalLiveSessionsNames: any = [{ "name": "SC Live Sessions" }, { "name": "CR Live Sessions" }, { "name": "RC Live Sessions" }, { "name": "Verbal Live Sessions" }];
  QuantLiveSessionsNames: any = [{ "name": "Quant Live Sessions" }, { "name": "CR Live Sessions" }];
  paidUser: boolean = false;
  paidUserToken: string = "";
  showBar: boolean = false;
  isPopBeforeDays: boolean = true;
  popBeforeCourseList = [];
  isPopExpired: boolean = false;
  popStatus: boolean = false;
  popName: string;
  popExpiredCourseList = [];
  isCourseExpiryPop: boolean = false;
  isCourseExtensionPop: boolean = false;
  isUserHasPSPPlan: boolean = false;
  showPDSSubMenu: boolean = false;
  showFAQSubMenu: boolean = false;
  showPoliciesSubMenu: boolean = false;
  userNewPlanPop: boolean = false;
  hasPlatinumAcces: boolean = false;
  verbalScholBadge: string = '';
  quantScholBadge: string = '';
  mockEnabled: string = 'DISABLED';
  GSmenu = {
    "menu": [],
    "policies": []
  };
  practice = [];
  excludeCourseFromMenu = ['Multi Source Reasoning'];
  mockTestMenuItem = {};
  publicSiteURL = AppSettings.publicSiteURL;
  gettingStartedLinks = [
    { "name": "Your Study Plan", "defaultPageName": "/page/your_study_plan" },
    // {"name":"System Requirements","defaultPageName":"helloworld"},
    { "name": "GMAT Planner", "defaultPageName": "https://gmatplanner.egmat.com/" },
    { "name": "Mock Tests", "defaultPageName": "helloworld" },
    // {"name":"Batch and Live Session Schedule","defaultPageName":"helloworld3"},
    // {"name":"How to Attend Live Sessions","defaultPageName":"helloworld4"},
    { "name": "How to Post Queries in Forums", "defaultPageName": "helloworld5" },
    { "name": "How to solve OG Quizzes", "defaultPageName": "helloworld6" },
    { "name": "Live Sessions", "defaultPageName": "helloworld6" },
    { "name": "System Requirements", "defaultPageName": "helloworld" }
    // {"name":"Batch and Live Session Schedule","defaultPageName":"helloworld"},
    // {"name":"Batch and Live Session Schedule","defaultPageName":"helloworld"}
  ];
  policies = [
    { "name": "Extension Policies", "defaultPageName": "helloworld" },
    { "name": "Support Policies", "defaultPageName": "/user/extensions" }
  ];
  @ViewChild('egSidebarMenuContent', { static: true }) elementViewSidebarHeight: ElementRef;
  @ViewChild('egSidebarMenuContent', { static: true }) elementViewSidebarWidth: ElementRef;
  public courses = {
    "VERBAL": [],
    "QUANT": [],
    "MOCK": [],
    "IntegratedReasoning": [],
    "VerbalLiveSessions": [],
    "QuantLiveSessions": [],
    "Scholaranium": [{ "name": "Verbal Scholaranium", "url": "https://scholaranium2.e-gmat.com/schol-20/verbal/dashboard", "paid": false },
    { "name": "Quant Scholaranium", "url": "https://scholaranium2.e-gmat.com/schol-20/quant/dashboard", "paid": false },
    { "name": "Verbal OG", "url": "https://scholaranium2.e-gmat.com/schol-20/og_verbal/dashboard", "paid": false },
    { "name": "Quant OG", "url": "https://scholaranium2.e-gmat.com/schol-20/og_quant/dashboard", "paid": false }],
    "FreeTrial": [{ "name": "Free Trial", "defaultPageName": "free_trial" }]
  };
  isSidebarVisible = false;
  public sidebarWidth = 0;
  lockImageURL: string = AppSettings.cdnUrl + 'assets/images/lock-image.png';
  showRefreshApplicationPopup: boolean = false;
  extensionAction: string = "NA";
  extensionTrackingParam: string = "";
  extensionButtonLabel: String = "";
  extensionButtonUrl: string = "";
  extensionParamConfig: Object = {
    "NA": {
      "buttonLabel": "",
      "trackingParam": "",
      "buttonUrl": ""
    },
    "EXTENSION": {
      "buttonLabel": "Extend Access",
      "trackingParam": "ext1",
      "buttonUrl": "https://learn.e-gmat.com/products/extensions-and-upgrades?utm_source=extend_button"
    },
    "REPURCHASE": {
      "buttonLabel": "Repurchase",
      "trackingParam": "repbtn1",
      "buttonUrl": "https://learn.e-gmat.com/products/extensions-and-upgrades?utm_source=repurchase_button"
    }
  };
  freeTrialMenuItems = {};
  courseExpiryTime = new Date();
  isCourseExpired: boolean = false;
  pspSegmentCheckURL = 'https://learn.e-gmat.com/finding-study-plan?utm_source=blitzkrieg&utm_medium=free_trial';
  allCourses:CourseResponse;
  showGFEPSPSubMenu = false;
  examType:string = '';
  //public sidebarHeight = 0;
  constructor(private httpClientService: HttpClientService, private userService: UserService, private router: Router, private sessionService: SessionService, private http:HttpClient, private eventService: EventService) {
    this.logoUrl = AppSettings.cdnUrl + "assets/images/Logo.png";
    this.menuImgUrl = AppSettings.cdnUrl + "assets/images/Menu_Icon.png";
    this.openMenuImgUrl = AppSettings.cdnUrl + "assets/images/Menu_Icon_Open_Menu.png";
    this.lockImage = AppSettings.cdnUrl + "assets/images/locked.png";
    this.homeMenuHover = AppSettings.cdnUrl + "assets/images/home_menu_hover.png";
    this.homeMenu = AppSettings.cdnUrl + "assets/images/home_menu.png";
    this.extensionIcon = AppSettings.cdnUrl + "assets/images/extend_icon.png";
    this.extensionBlueIcon = AppSettings.cdnUrl + "assets/images/extend_blue_icon.png";
    this.extensionOrangeIcon = AppSettings.cdnUrl + "assets/images/extend_orange_icon.png";
  }
  ngOnInit() {
    this.getPaidStatus();
    this.getUserProfile();
    this.getCourses();
    this.updateUserProfile();
    if (this.router.url !== '/extend-course') {
      this.getExtensionPopUp();
    }
  }

  toggleSidebar(event?:Event) {
    event ? event.stopPropagation() : null;
    const height = this.elementViewSidebarHeight.nativeElement.offsetHeight < 814 ? 814 : this.elementViewSidebarHeight.nativeElement.offsetHeight;
    const width = this.elementViewSidebarWidth.nativeElement.clientWidth;
    if (this.paidUser && !this.hasSeenGS) {
      this.httpClientService.post(AppSettings.restApiUrl + '/api/user/seenGettingStarted', null, new HttpHeaders()).subscribe((data) => {
      });
    }
    if (!this.isSidebarVisible) {
      this.isSidebarVisible = true;
      this.sidebarWidth = width;
      this.sidebarHeight = height;
    }
    else {
      this.isSidebarVisible = false;
      this.sidebarWidth = 0;
      this.sidebarHeight = 0;
    }
  }

  public closeSidebar(event) {


    if (this.isSidebarVisible && event.srcElement.className != "eg-menu-icon") {
      this.isSidebarVisible = false;
      this.sidebarWidth = 0;
      this.sidebarHeight = 0;
    }
  }

  logout() {
    this.userService.logout();
  }

  /**
   *
   * @param courseName
   * @returns
   */
  validateClick(coursePath:string) {
    if(this.httpClientService.isValidUrl(coursePath)){
      // if link is a full url opens in a new tab
      window.open(coursePath,'_blank');
    }else{
      var pageLink = coursePath;
      this.sessionService.updatePageName(coursePath);
      this.router.navigate(['page/' + pageLink]);
    }
    this.toggleSidebar();
    return false;
  }

  get activeTabCourses(): Courses[]{
    if(!!this.tabActive && this.allCourses){
      const tab  = this.allCourses.sectionList.find(item=>item.name===this.tabActive);
      return tab ? tab.courseList : [];
    } else {
      return []
    }
  }

  /**
   * @description gets the courses
   */
  getCourses():void{
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/course-menu', headers).subscribe((courseResponse:CourseResponse)=>{
      this.allCourses = this.groupCourses(courseResponse);
      this.tabActive = courseResponse.sectionList[0].name;
    });
  }

  practiceRoute() {
    this.toggleSidebar();
    window.open(this.practice[0].defaultPageName, "_blank");
  }


  getPaidStatus() {
    this.httpClientService.get(AppSettings.restApiUrl + '/api/user/isFreeTrial', new HttpHeaders()).subscribe((data) => {
      this.paidUser = data ? false : true;
      this.paidUserToken = data ? "NO" : "YES";
      this.sessionService.shareUserPaidStatus(this.paidUserToken);
      this.getGettingStartedSections();
    });
  }
  getGettingStartedSections() {
    this.httpClientService.get(AppSettings.restApiUrl + '/api/public/getting_started/sections', new HttpHeaders()).
      subscribe((data) => {
        this.gettingStartedSection = data;
        this.sessionService.shareGettingStarted(this.gettingStartedSection);
        for (let i = 0; i < this.gettingStartedSection.length; i++) {
          if (this.gettingStartedSection[i].name.indexOf('Policies') > -1) {
            this.gettingStartedSection[i]['i'] = i;
            this.GSmenu['policies'].push(this.gettingStartedSection[i]);
            this.showBar = true;
          }
          else {
            if (this.gettingStartedSection[i].name.indexOf("Live") > -1) {
              this.liveSessionId = i;
            }
            this.gettingStartedSection[i]['i'] = i;
            this.GSmenu['menu'].push(this.gettingStartedSection[i]);
          }
        }
      });
  }
  getExtensionPopUp() {
    this.httpClientService.get(AppSettings.restApiUrl + '/api/package/popup', new HttpHeaders()).
      subscribe((data) => {
        for (let i = 0; i < data.length; i++) {
          let courseList = {};
          if (data[i].popup7daysBeforeExpiry || data[i].popup2daysBeforeExpiry) {
            this.isPopBeforeDays = true;
            courseList["courseName"] = data[i].name;
            courseList["days"] = data[i].daysRemaining;
            this.popBeforeCourseList.push(courseList);
            this.isCourseExtensionPop = true;
          }
          if (data[i].popupAfterExpiry) {
            courseList["courseName"] = data[i].name;
            this.isPopExpired = true;
            this.popExpiredCourseList.push(courseList);
            this.isCourseExpiryPop = true;
          }
        }
        if (this.isCourseExtensionPop) {
          this.showExpiryPop('extensionPopup');
        }
        else if (this.isCourseExpiryPop) {
          this.showExpiryPop('expiryPopup');
        }
      });
  }
  showExpiryPop(popName) {
    this.popStatus = true;
    this.popName = popName;
    document.body.classList.add('coursePopIn');
  }
  closeExpiryPop(val: string) {
    if (val == 'extensionPopup') {
      this.isCourseExtensionPop = false;
    }
    if (val == 'expiryPopup') {
      this.isCourseExpiryPop = false;
    }
    document.body.classList.remove('coursePopIn');
  }
  redirectToYSP() {
    let properties = {};
    properties["GS_Channel"] = "gs_menu";
    properties["GS_Reason"] = "ysp";
    this.eventService.track("Accessed_Getting_Started", properties);
    this.router.navigateByUrl("page/your_study_plan");
  }
  redirectToPSP(pageName: string) {
    if (pageName === 'calendarUI') {
      if (this.isUserHasPSPPlan) {
        this.showPDSSubMenu = false;
        this.router.navigateByUrl("/your-calendar");
      }
    }
    else if (pageName === 'scoreUI') {
      if (this.isUserHasPSPPlan) {
        this.userNewPlanPop = true;
      }
      else {
        this.showPDSSubMenu = false;
        this.router.navigate(['/study-planner']);
      }
    }
    if (pageName === 'HTMLUI') {
      if (this.isUserHasPSPPlan) {
        this.showPDSSubMenu = false;
        this.router.navigateByUrl("/your-personalized-view");
      }
    }
  }
  redirectToPSPHome() {
    this.showPDSSubMenu = false;
    this.router.navigate(['/study-planner']);
  }

  redirectToGFEpsp(){
    window.open(AppSettings.gfePSPUrl, '_blank').focus();
  }
  routeToSection(event, index) {
    let currentObject = this.gettingStartedSection[index];
    let properties = {};
    properties["GS_Channel"] = "gs_menu";
    properties["GS_Reason"] = currentObject["gsReason"];
    this.eventService.track(currentObject.eventName, properties);
  }

  getUserProfile() {
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/user/info', headers)
      .subscribe(
        (data) => {
          this.examType = data.examType;
          this.fname = data.firstName;
          this.showUpgradeNowBtn = data.canUpgrade;
          this.userService.firstName = data.firstName;
          this.userService.email = data.username;
          this.userService.scoreKey800 = data.scoreKey800;
          // this.upgradeNowBtnURL = AppSettings.restApiUrl + '/api/package/upgrade';
          this.isUserHasPSPPlan = data.userCreatedGmatPlanner;
          this.setExtensionParams(data.extensionAction);
          this.setUserRole(data.roles);
          this.sessionService.setExpiredSubscriptionFlag(data.expiredSubscription);
          this.sessionService.getUserInfo(data);
          this.sessionService.shareVerbalLsStateStarted(data.verbalLSTileStateId);
          this.sessionService.shareTirialOfferExpiryDateStarted(data.lsTrialOfferExpiryDate);
          this.sessionService.shareTirialOfferExpiryDateStarted(data.lsTrialOfferExpiryDate);
          this.sessionService.shareExpiryDate(data.lsExpiryDate)
          this.sessionService.updateUserAppcuesSplashScreenFlag(data.userAppcuesSplashScreenFlag)
        }
      );
  }

  setExtensionParams(extensionAction) {
    if (extensionAction != null)
      this.extensionAction = extensionAction;
    this.extensionButtonLabel = this.extensionParamConfig[this.extensionAction]['buttonLabel'];
    this.extensionButtonUrl = this.extensionParamConfig[this.extensionAction]['buttonUrl'];
    this.extensionTrackingParam = this.extensionParamConfig[this.extensionAction]['trackingParam'];
  }

  setUserRole(roles) {
    if (roles != null) {
      let index = roles.findIndex((item) => item['name'] == "ROLE_EXPERT");
      if (index > -1) {
        this.setCookie("expert", "true", 1);
      }
      else {
        this.setCookie("expert", "false", 1);
      }
    }
    else {
      this.setCookie("expert", "false", 1);
    }
  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    let hostName = window.location.hostname;
    let domain = hostName.split('.').reverse()[1] + "." + hostName.split('.').reverse()[0];
    document.cookie = name + "=" + (value || "") + expires + ";domain=." + domain + "; path=/";
  }
  updateUserProfile() {

    this.userInfoUpdateSubscription = this.sessionService.updateuserInfo$.
      subscribe(item => {
        if (item != 0) {
          this.getUserProfile();
          this.getCourses();
        }
      }
      );
  }
  openLinkInTab(event, index) {
    let currentObject = this.gettingStartedSection[index];
    let properties = {};

    properties["GS_Channel"] = "gs_menu";
    properties["GS_Reason"] = currentObject["gsReason"];

    this.eventService.track("Accessed_Getting_Started", properties);
    window.open(currentObject.externalURL, "_blank");
  }

  eventFire(event) {
    if (event.target.text == "GMAT Planner") {
      let properties = {};
      properties["GS_Channel"] = "gs_menu";
      properties["GS_Reason"] = "gmat_planner";
      this.eventService.track("Accessed_Getting_Started", properties);
      window.open("http://gmatplanner.e-gmat.com/", "_blank");


    } else if (event.target.text == "Your Study Plan") {
      let properties = {};
      properties["GS_Channel"] = "gs_menu";
      properties["GS_Reason"] = "ysp";
      this.eventService.track("Accessed_Getting_Started", properties);

    }
    else if (event.target.text == "Extension Policies") {
      let properties = {};
      properties["GS_Channel"] = "gs_menu";
      properties["GS_Reason"] = "ext_policies";
      this.eventService.track("Accessed_Getting_Started", properties);
      this.router.navigateByUrl('/user/extensions');

    }
    else if (event.target.text == "Free Trial") {
      let properties = {};
      properties["GS_Channel"] = "gs_menu";
      properties["GS_Reason"] = "free_trial";
      this.eventService.track("Accessed_Getting_Started", properties);
      this.sessionService.updatePageName("free_trial");
      this.router.navigateByUrl('/page/free_trial');
    }
    else if (event.target.text == "Batch and Live Session Schedule") {
      let properties = {};
      properties["GS_Channel"] = "gs_menu";
      properties["GS_Reason"] = "live_sessions";
      this.eventService.track("Accessed_Getting_Started", properties);
      this.router.navigateByUrl('/getting-started/' + this.liveSessionId);
    }
  }
  /**
   * @description sets the selected tab name from menu
   * @param tabName
   */
  toggleTab(tabName: string) {
    this.tabActive = tabName;
    const height = this.elementViewSidebarHeight.nativeElement.offsetHeight < 814 ? 814 : this.elementViewSidebarHeight.nativeElement.offsetHeight;
    this.sidebarHeight = height;
  }
  //  getIpadOS()
  // {
  //   let a;
  //   if (typeof navigator != 'undefined' || typeof window != 'undefined')
  //   {
  //     a= navigator.userAgent || navigator.vendor || window.opera || 'not detected';
  //   }
  //   else
  //   {
  //     a = 'unknown';
  //   }
  //   return a;
  // }

  routeMeToSection(event, index) {
    //this.sessionService.updateSelectedGettingStartedItem("section"+index);
  }
  blurBackground(action: string) {
    if (action === 'add') {
      document.body.classList.add('coursePopIn');
    }
    else {
      document.body.classList.remove('coursePopIn');
    }

  }
  checkApplicationState() {
    let cookie = this.getCookie("PurchaseTime");
    if (cookie != null) {
      if (parseInt(this.getLocalStorageValue("menuRefreshTime")) <= parseInt(this.getCookie("PurchaseTime"))) {
        this.showRefreshApplicationPopup = true;
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return true;
    }
  }
  refreshApplication() {
    window.location.reload();
    this.setLocalStorageValue("menuRefreshTime", Math.floor((new Date()).getTime()).toString());
  }
  getLocalStorageValue(varName) {
    return localStorage.getItem(varName);
  }
  setLocalStorageValue(varName, value) {
    localStorage.setItem(varName, value);
  }
  getCookie(cookieName) {
    var nameEQ = cookieName + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  redirectToExtension(device) {
    this.trackPageLoad();
    if (device == 'mobile') {
      this.toggleSidebar();
    }
    this.router.navigateByUrl("/user/extensions?src=" + this.extensionTrackingParam);
  }
  trackPageLoad() {
    let url = window.location.href;
    let pageName = url.split('/')[url.split('/').length - 1];
    let pageProperties = this.pageProperties();
    this.eventService.page(pageName, pageProperties);
  }

  pageProperties() {
    let properties = {};
    properties['path'] = window.location.pathname;
    properties['referrer'] = document.referrer;
    properties['search'] = window.location.search;
    properties['title'] = document.title;
    properties['url'] = window.location.href;
    return properties;
  }
  ngOnDestroy() {
    this.userInfoUpdateSubscription.unsubscribe();
  }

  /**
   * @description groups courses
   * @param courseResponse
   * @returns
   */
  private groupCourses(courseResponse:CourseResponse):courseResponse{
    for (let index = 0; index < courseResponse.sectionList.length; index++) {
      const element = courseResponse.sectionList[index];
      const groups = element.courseList.reduce((acc,current)=>{
        if(current.separatorRequired){
          current.separatorRequired = false;
          acc[current.separatorText] ?  acc[current.separatorText].push(current) : acc[current.separatorText] = [current];
        } else {
          acc['none'] ? acc['none'].push(current) :acc['none'] = [current];
        }
        return acc;
      },{});

      let groupedElement = [];
      if(groups['none'] && groups['none'].length){
        groupedElement  = [...groups['none']];
       delete groups['none'];
      }
      for(let prop in groups) {
        const crs = new Course({separatorText:prop,separatorRequired:true});
        groupedElement.push(crs);
        groupedElement.push(...groups[prop]);
      }
      element.courseList = groupedElement;
    }
    return courseResponse;
  }
}